import { registerLogger } from '@vue-storefront/core';
const customLogger = require('@unified-commerce/dev-tooling-scripts/scripts/customLogger');

const setupLogger = () => {
  if (typeof customLogger === 'function') {
    registerLogger(customLogger(), 'warn');
  }
};

export default setupLogger;
